// extracted by mini-css-extract-plugin
export default {"productGallery":"uI-z","inQuickShop":"vI-z"};